import { render, staticRenderFns } from "./generalConditionsPage.vue?vue&type=template&id=ab69fa98"
import script from "./generalConditionsPage.vue?vue&type=script&lang=ts"
export * from "./generalConditionsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports